import { render, staticRenderFns } from "./PatentList.vue?vue&type=template&id=08842572"
import script from "./PatentList.vue?vue&type=script&lang=js"
export * from "./PatentList.vue?vue&type=script&lang=js"
import style0 from "./PatentList.vue?vue&type=style&index=0&id=08842572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports